import { CommonService } from "../../services/common/commonService";
import { Outlet } from "react-router-dom";

const TrackingLayout = () => {
  return (
    <>
      <CommonService>
        <div className='admin-wrapper min-h-svh py-6 px-4 flex items-center justify-center bg-body-color after:fixed after:w-full after:h-full after:start-0 after:top-0 after:opacity-90 after:bg-[url("../../assets/images/auth.png")]'>
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
      </CommonService>
    </>
  );
};

export default TrackingLayout;
